module.exports = __webpack_public_path__ + "static/media/end-availability.6d8b36a1.svg";